<template>
  <div>
    <div id="wordCloud" style="width: 100vm; height: 380px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-wordcloud'
import api from '../../../api/Sns'
import snsApi from '../../../api/SnsData'

export default {
	name: 'WordCloud',
	props: {
		searchParams: {
			type: Object,
			default: {}
		}
	},
	data () {
		return {
			maskImage: new Image(),
			wordCloudData: [],
			option: {
				series: [{
					type: 'wordCloud',
					left: 'center',
					top: 'center',
					width: '100%',
					height: '100%',
					sizeRange: [20, 130],
					rotationRange: [0, 0],
					rotationStep: 20,
					gridSize: 0,
					shape: 'circle',
					maskImage: this.maskImage,
					drawOutOfBound: false,
					layoutAnimation: true,
					data: []
				}]
			}
		}
	},

	watch: {
		searchParams: function () {
			this.searchWordCloud()
		}
	},

	created () {},

	mounted () {
		this.$nextTick(function () {
			this.chart = echarts.init(document.getElementById('wordCloud'))
		})
	},

	methods: {
		chartResize () {
			if (this.chart) {
				this.chart.resize()
			}
		},

		async searchWordCloud () {
			// this.searchParams['rowCount'] = this.searchCount
			// const searchData = await api.searchWordCloud(this.searchParams.keyword, this.searchParams) //기존 sns api
			const searchData = await snsApi.searchWordCloud(this.searchParams.keyword, this.searchParams) // 개발DB

			if (searchData.data) {
				for (const data of searchData.data) {
					data.textStyle = {
						color: 'rgb(' + [Math.round(Math.random() * 160), Math.round(Math.random() * 160), Math.round(Math.random() * 160)].join(',') + ')'
					}
					data.emphasis = {
						textStyle: { color: 'red' }
					}
				}
				this.wordCloudData = searchData.data
				this.maskImage.src = require('@/assets/img/wordcloud/1.png')
				this.maskImage.onload = this.eventLoadWordCloudImage
			}
		},

		eventLoadWordCloudImage () {
			this.option.series[0].maskImage = this.maskImage
			this.option.series[0].data = this.wordCloudData
			this.option.series[0].gridSize = 10
			this.chart.setOption(this.option)
		}
	}
}
</script>

<style scoped>

</style>
